import { usePage } from '@inertiajs/react';

const Notification = ({ }) => {
  
    const { notification } = usePage().props;

    return (
      <>
        {notification ? (
          <div className="border-b border-gray-300 bg-yellow-100 w-full text-center text-xs py-[4px] px-2">
              {notification}
          </div>
        ) : ""}
      </>
    ); 
  };

export default Notification;